<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          color="indigo"
          style="width:250px;"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left>
            mdi-image
          </v-icon>
          <span>Changer L'image</span>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Badge
        </v-card-title>

        <v-card-text>
          <main-image-form
            @mainImageFormSent="handleMainImageForm"
          ></main-image-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainImageForm from './MainImageForm.vue';

export default {
  components: {
    MainImageForm,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    handleMainImageForm(res) {
      console.log('handleMainImageForm res: ', res);
      this.dialog = false;
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.super-class {
  background: #4b79b6;
}
</style>
